import { Directive, HostBinding, Input } from '@angular/core';

@Directive({
    selector: '[appPageLayout],app-page-layout',
    host: {
        class: 'app-page-layout'
    },
    standalone: false
})
export class PageLayoutDirective {

  @Input() mode: 'card' | 'simple' = 'simple';

  constructor() { }

  @HostBinding('class.app-page-layout-card')
  get isCard() {
    return this.mode === 'card';
  }

  @HostBinding('class.app-page-layout-simple')
  get isSimple() {
    return this.mode === 'simple';
  }

}
